import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { Circle, Play, Square, Globe, Edit, GitBranch, Code, Webhook, Merge, Split, FunctionSquare, Filter, Repeat, GitFork, Clock, AlertCircle, Workflow, Cpu } from 'lucide-react';

const iconMap = {
  play: Play,
  square: Square,
  globe: Globe,
  edit: Edit,
  'git-branch': GitBranch,
  code: Code,
  webhook: Webhook,
  merge: Merge,
  split: Split,
  'function-square': FunctionSquare,
  filter: Filter,
  repeat: Repeat,
  'git-fork': GitFork,
  clock: Clock,
  'alert-circle': AlertCircle,
  workflow: Workflow,
  cpu: Cpu,
};

const CustomNode = ({ data, selected }) => {
  const IconComponent = iconMap[data.icon] || Circle;

  const handleClick = (e) => {
    e.stopPropagation();
    // Dispatch custom event to open sidebar at page level
    window.dispatchEvent(new CustomEvent('openNodeConfig', { 
      detail: { nodeType: data.nodeType } 
    }));
  };

  return (
    <div
      onClick={handleClick}
      className={`px-4 py-3 shadow-lg rounded-node border-2 transition-all cursor-pointer ${
        selected ? 'border-primary shadow-neon' : 'border-slate-700'
      }`}
      style={{ backgroundColor: data.color || '#101330', minWidth: '150px' }}
      data-testid={`node-${data.nodeType}`}
      title="Click para ver configuración"
    >
      {/* Conexiones laterales (eje X) */}
      <Handle type="target" position={Position.Left} className="w-3 h-3 !bg-primary" />
      <div className="flex items-center gap-2">
        <IconComponent className="w-5 h-5 text-white" />
        <div className="text-white font-heading font-bold text-sm">{data.label}</div>
      </div>
      <Handle type="source" position={Position.Right} className="w-3 h-3 !bg-primary" />
    </div>
  );
};

export default memo(CustomNode);